// extracted by mini-css-extract-plugin
export default {"root":"lsjsHYs5","line":"NMGAgWnT","dot":"VuQ_mKnD"};